<template lang="html">
  <section>
    <div class="chevrons" @click="onClickChevron" :disabled="disabled">
      <div class="svg-small" v-if="!isLarge">
        <svg v-if="isOpen">
          <use
            xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#chevrondown"
          ></use>
        </svg>
        <svg v-else>
          <use
            xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#chevronright"
          ></use>
        </svg>
      </div>
      <div class="svg-large" v-if="isLarge">
        <svg v-if="isOpen">
          <use
            xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#chevrondown"
          ></use>
        </svg>
        <svg v-else>
          <use
            xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#chevronright"
          ></use>
        </svg>
      </div>
    </div>
  </section>
</template>

<script lang="js">

  export default  {
    name: "chevrons",
    props: {
      isOpen: {
        type: Boolean,
        default: false
      },
      isLarge: {
        type: Boolean,
        default: false
      },
      disabled: Boolean
    },
    methods: {
      onClickChevron() {
        if(!this.disabled) {
          this.$emit("on-chevon-click", {open: !this.isOpen});
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .chevrons {
    flex: 1;
    min-width: 0;
    width: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    .svg-small > svg {
      width: 0.7rem;
      height: 0.7rem;
    }
    .svg-large > svg {
      width: 1rem;
      height: 1rem;
    }
    &[disabled] {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }
</style>
